export default __webpack_public_path__ + "static/media/Group12.e047c18d.png";